export interface TimesheetPeriodTypeClass {
    AccountTimesheetPeriodTypeId : string
    SystemTimesheetPeriodTypeId : number
    SystemTimesheetPeriodType : string
    SystemInitialDaysOfThePeriodId:number
    SystemInitialDaysOfThePeriod:string
    InitialDayOfTheMonth : number
    LastDayOfTheMonth : number
    AccountId: number
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    IsDisabled: boolean
    MasterTimesheetPeriodTypeId : number
    TimesheetPeriodEffectiveDate : Date | undefined
    isSelected:number
}

const common = {    
    SystemTimesheetPeriodTypeId : 0,
    SystemInitialDaysOfThePeriodId:0,
    InitialDayOfTheMonth : 0,
    LastDayOfTheMonth :0,
    AccountId: 0,
    IsDisabled: false,
    MasterTimesheetPeriodTypeId : 0,
    TimesheetPeriodEffectiveDate : null
  };
  
  export const TimesheetPeriodTypeInitialsForAdd = { ...common };
  
  export const TimesheetPeriodTypeInitialsForUpdate = {
    ...common,
    AccountTimesheetPeriodTypeId:0
  };
  

